














































import { Component, Vue, Watch } from 'vue-property-decorator';
import _ from 'lodash';
import { Spinner } from 'vue-image-spinner2';
import { mapState } from 'vuex';
import { State } from 'vuex-class';


@Component({
    name: 'email-feedback-pdv-modal',
    components: {
        Spinner,
    }
})
export default class EmailFeedbackPDVModal extends Vue {
    @State('activeFeedbackInvoicePDV', { namespace: 'feedbackInvoicesPDV' }) 
    activeFeedbackInvoicePDV!: any;

    @State('activeFeedbackInvoicePDVLoading', { namespace: 'feedbackInvoicesPDV' }) 
    activeFeedbackInvoicePDVLoading!: boolean;

    // Inicializa como array vacío
    public recipients: any[] = [];
    public newEmail: string = '';

    // Inicializa los recipients cuando el modal se abre
    mounted() {
        this.initializeRecipients();
    }

    private initializeRecipients() {
        if (this.activeFeedbackInvoicePDV?.invoice_data?.email) {
            this.recipients = [
                {
                    email: this.activeFeedbackInvoicePDV.invoice_data.email,
                    isDefault: true,
                    role: 'client'
                }
            ];
        }
    }

    public addEmail() {
        if (this.newEmail && this.validateEmail(this.newEmail)) {
            const exists = this.recipients.some((email) => email.email === this.newEmail);
            if (!exists) {
                this.recipients.push({ email: this.newEmail, isDefault: false, role: 'extra'});
                this.newEmail = '';
            } else {
                this.$bvToast.toast('El correo eletrónico ya se ingresó.', {
                    title: `Correo existente`,
                    variant: 'warning',
                    toaster: 'b-toaster-top-center',
                    autoHideDelay: 5000,
                });
            }
        } else {
            this.$bvToast.toast('Por favor, ingresa un correo válido.', {
                title: `Correo inválido`,
                variant: 'warning',
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
            });
        }
    }

    public removeEmail(index: number) {
        if (!this.recipients[index].isDefault) {
            this.recipients.splice(index, 1);
        }
    }

    private validateEmail(email: string): boolean {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    public sendEmails() {
        this.$bvModal.hide('email-feedback-pdv-modal');
        console.log(this.activeFeedbackInvoicePDV);
        
        this.$store.dispatch('feedbackInvoicesPDV/sendInvoice', { 
            emails: this.recipients, 
            id: this.activeFeedbackInvoicePDV.id, 
            view: this 
        });
    }

    @Watch('activeFeedbackInvoicePDV', { immediate: true, deep: true })
    onActiveFeedbackInvoiceChange(newValue: any) {
        if (newValue?.invoice_data?.email) {
            // Limpia y reinicializa los recipients cuando cambia activeFeedbackInvoicePDV
            const exists = this.recipients.some((recipient) => recipient.email === newValue.invoice_data.email);

            if (!exists) {
                this.recipients = [
                    {
                        email: newValue.invoice_data.email,
                        isDefault: true,
                        role: 'client'
                    }
                ];
            }
        }
    }
}
